import { Row, Col, Modal, ProgressBar } from 'react-bootstrap';
import { useRef, useEffect, useState } from 'react';
import { Tooltip, Button, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faRainbow, faSms, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import Messages from 'src/components/chat/messages';
import { PieChart, Series, Connector, Legend, Animation, Label, Font, Size } from 'devextreme-react/pie-chart';
import ChatService from 'src/services/chatservice';
function AnalysisByMoodModal(props) {

    const { interaction, show, toggleModal, rtl } = props;

    const { t } = useTranslation();
    const messagesRefs = useRef([]);
    const [criteria, setCriteria] = useState([{ concept: "negative", value: 0 }, { concept: "neutral", value: 0 }, { concept: "positive", value: 0 }]);
    const colorMap = {
        negative: '#f1416c',
        neutral: '#b2b3bb',
        positive: '#50cd89'
    };
    const [emailUrl, setEmailUrl] = useState("");

    useEffect(() => {

        if (show) {

            let neutral = 0;
            let positive = 0;
            let negative = 0;

            interaction.evaluableConcepts.forEach(c => {
                if (c.evaluation >= 70)
                    positive += 1;

                if (c.evaluation > 30 && c.evaluation < 70)
                    neutral += 1;

                if (c.evaluation <= 30)
                    negative += 1
            });

            setCriteria([{
                concept: "negative",
                value: negative
            }, {
                concept: "neutral",
                value: neutral
            }, {
                concept: "positive",
                value: positive
            }]);

        }

    }, [interaction, show]);

    useEffect(() => {
        if (show && interaction?.channel.toLowerCase() === "mail" && interaction?.guid) {
            ChatService.getChatById(interaction?.guid, res => {
                if (res?.data?.emailUrl) {
                    setEmailUrl(res?.data?.emailUrl);
                }
            });
        }
    }, [interaction?.id, show]);


    const getIcon = () => {
        let elem = <FontAwesomeIcon size='lg' icon={duotone("messages")} />;
        let channel = "";

        if (interaction.channel !== null)
            channel = interaction.channel.toLowerCase();

        if (channel === "facebook")
            elem = <FontAwesomeIcon size='lg' icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon size='lg' icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon size='lg' icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon size='lg' icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon size='lg' icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon size='lg' icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon size='lg' icon={faRainbow} />;
        if (channel === "mail")
            elem = <FontAwesomeIcon size='lg' icon={faEnvelope} />;
        if (channel === "call")
            elem = <FontAwesomeIcon size='lg' icon={faPhone} />;

        return <> <span className="fw-bold text-primary text-center">{elem}</span> {t(channel)}</>;
    }

    const customizeText = (arg) => {
        return `${arg.valueText} (${arg.percentText}) ${t(arg.argumentText)}`;
    }

    const customizePoint = (pointInfo) => ({
        color: colorMap[pointInfo.argument]
    });

    return (
        <Modal show={show} onHide={toggleModal} size="xl">
            <Modal.Header>
                <Modal.Title><FontAwesomeIcon icon={duotone("file-chart-column")} /> {t("analysisbymood")}</Modal.Title>
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip style={{ position: "fixed" }}>
                        {t("close")}
                    </Tooltip>}>
                    <Button onClick={toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                </OverlayTrigger>
            </Modal.Header>
            <Modal.Body style={{ height: "80vh", overflow: "auto", backgroundColor: "var(--kt-page-bg)" }}>
                <Row>
                    <Col>
                        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
                            <div className="card-body" style={{ "padding": "1rem" }}>
                                <Row>
                                    <Col><span class="card-label fw-bold text-primary">{t("channel")}</span></Col>
                                    <Col><span class="card-label fw-bold text-primary">{t("Client")}</span></Col>
                                    <Col><span class="card-label fw-bold text-primary">{t("initialmood")}</span></Col>
                                    <Col><span class="card-label fw-bold text-primary">{t("finalmood")}</span></Col>
                                    <Col><span class="card-label fw-bold text-primary">{t("agent")}</span></Col>
                                    <Col><span class="card-label fw-bold text-primary">{t("category")}</span></Col>
                                    <Col><span class="card-label fw-bold text-primary">{t("datetime")}</span></Col>
                                </Row>
                                <Row>
                                    <Col>{getIcon()}</Col>
                                    <Col>{interaction.interlocutor}</Col>
                                    {
                                        interaction.initialMood === "negative" &&
                                        <Col><span><FontAwesomeIcon icon={duotone("face-angry")} className="text-danger" /> {t("negative")}</span>;</Col>
                                    }

                                    {
                                        interaction.initialMood === "positive" &&
                                        <Col><span><FontAwesomeIcon icon={duotone("face-smile")} className="text-success" /> {t("positive")}</span>;</Col>
                                    }

                                    {
                                        interaction.initialMood === "neutral" &&
                                        <Col><span><FontAwesomeIcon icon={duotone("face-meh")} className="text-gray-800s" /> {t("neutral")}</span>;</Col>
                                    }

                                    {
                                        interaction.finalMood === "negative" &&
                                        <Col><span><FontAwesomeIcon icon={duotone("face-angry")} className="text-danger" /> {t("negative")}</span>;</Col>
                                    }

                                    {
                                        interaction.finalMood === "positive" &&
                                        <Col><span><FontAwesomeIcon icon={duotone("face-smile")} className="text-success" /> {t("positive")}</span>;</Col>
                                    }

                                    {
                                        interaction.finalMood === "neutral" &&
                                        <Col><span><FontAwesomeIcon icon={duotone("face-meh")} className="text-gray-800s" /> {t("neutral")}</span>;</Col>
                                    }
                                    <Col>{interaction.userFullname}</Col>
                                    <Col>{interaction.classificationTag}</Col>
                                    <Col>{new Date(interaction.dateTime).toLocaleString()}</Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={(interaction.channel.toLowerCase() !== "mail" ? 4 : 6)}>
                        <div className="card card-flush overflow-hidden h-lg-20 widget-container" style={{ marginTop: "20px" }}>
                            <div className="card-body" style={{ "padding": "1rem" }}>
                                <Row><Col><span class="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("scroll")} /> {t("transcription")}</span></Col></Row>
                                <Row>
                                    <Col style={{ height: "58vh", overflow: "auto" }}>

                                        {
                                            interaction?.channel.toLowerCase() === "call" &&
                                            <p style={{ whiteSpace: "pre-line" }}>{interaction.content}</p>
                                        }

                                        {
                                            interaction?.channel.toLowerCase() !== "call" && interaction?.channel.toLowerCase() !== "mail" &&
                                            <Messages chat={{
                                                messages: JSON.parse(interaction.content).map(message => ({
                                                    ...message,
                                                    name: message.name || interaction.userFullname
                                                })), channel: interaction.channel
                                            }} messagesRefs={messagesRefs} />
                                        }
                                        {
                                            interaction?.channel.toLowerCase() === "mail" &&
                                            <iframe title="Mail" src={emailUrl} width={"100%"} height={"720px"}></iframe>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col lg={(interaction.channel.toLowerCase() !== "mail" ? 8 : 6)}>
                        <Row>
                            <Col>
                                <div className="card card-flush overflow-hidden h-lg-20 widget-container" style={{ marginTop: "20px" }}>
                                    <div className="card-body" style={{ "padding": "1rem" }}>
                                        <Row><Col><span class="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("audio-description")} /> {t("summary")}</span></Col></Row>
                                        <Row>
                                            <Col style={{ height: (interaction.channel.toLowerCase() !== "mail" ? "23.3vh" : "60vh"), overflow: "auto" }}>
                                                <p style={{ whiteSpace: "pre-line" }}>{interaction.summary}</p>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            {
                                interaction.channel.toLowerCase() !== "mail" &&
                                <Col>
                                    <div className="card card-flush overflow-hidden h-lg-20 widget-container" style={{ marginTop: "20px" }}>
                                        <div className="card-body" style={{ "padding": "1rem" }}>
                                            <Row><Col><span class="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("face-smile")} /> {t("sentimentsummary")}</span></Col></Row>
                                            <Row>
                                                <Col>
                                                    <PieChart
                                                        key={"analysisbycriteriamodal"}
                                                        id="analysisbycriteriamodal"
                                                        dataSource={criteria}
                                                        type="doughnut"
                                                        resolveLabelOverlapping="shift"
                                                        rtlEnabled={rtl}
                                                        customizePoint={customizePoint}
                                                    >
                                                        <Size
                                                            height={220}
                                                        />
                                                        <Series
                                                            argumentField="concept"
                                                            valueField="value"
                                                            colorField=""
                                                        >
                                                            <Font size={16} />
                                                            <Label
                                                                visible={true}
                                                                customizeText={customizeText}
                                                            >
                                                                <Connector visible={true} width={1} />
                                                            </Label>
                                                        </Series>
                                                        <Legend visible={false}
                                                        ></Legend>
                                                        <Animation enabled={true}></Animation>
                                                    </PieChart>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            }
                        </Row>
                        {
                            interaction.channel.toLowerCase() !== "mail" &&
                            <Row>
                                <Col>
                                    <div className="card card-flush overflow-hidden h-lg-20 widget-container" style={{ marginTop: "40px" }}>
                                        <div className="card-body" style={{ "padding": "1rem" }}>
                                            <Row><Col><span class="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("magnifying-glass-chart")} /> {t("analysisbycriteria")}</span></Col></Row>
                                            <Row>
                                                <Col style={{ height: "23.3vh", overflow: "auto" }}>
                                                    {
                                                        interaction.evaluableConcepts.map((c, i) => {
                                                            return <Row key={`cat_${i}`}>
                                                                <Col lg={2} >
                                                                    <span style={{ lineHeight: "45px" }} className="text-gray-800 fw-semibold mb-7">{t(c.concept)}</span>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    {

                                                                        <ProgressBar style={{ marginTop: "15px" }}>
                                                                            {
                                                                                c.evaluation >= 70 &&
                                                                                < ProgressBar variant="success" now={c.evaluation} key={1} />
                                                                            }
                                                                            {
                                                                                c.evaluation > 30 && c.evaluation < 70 &&
                                                                                < ProgressBar variant="warning" now={c.evaluation} key={1} />
                                                                            }
                                                                            {
                                                                                c.evaluation <= 30 &&
                                                                                < ProgressBar variant="danger" now={c.evaluation} key={1} />
                                                                            }
                                                                            <ProgressBar style={{ backgroundColor: '#b2b3bb' }} now={100 - c.evaluation} key={2} />
                                                                        </ProgressBar>
                                                                    }
                                                                </Col>
                                                                <Col lg={1}>
                                                                    <span style={{ lineHeight: "45px" }} className="card-label fw-bold text-gray-800">{c.evaluation}%</span>
                                                                </Col>
                                                                <Col lg={5}>
                                                                    <p style={{ whiteSpace: "pre-line" }}>{c.explanation}</p>
                                                                </Col>
                                                            </Row>
                                                        })
                                                    }
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal >
    );
}

export default AnalysisByMoodModal;